<template>
  <div class="dashboard" v-infinite-scroll="getProducts" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-root>
    <v-container class="pt-6">
      <div class="overview wrapper">
        <h3>數據中心</h3>
        <span>本日統計資料</span>
        <v-tabs v-model="dashboard_tab" grow color="pink">
          <v-tab v-for="type in dashboard_types">
            {{ type.text }}
          </v-tab>
        </v-tabs>
        <v-tabs-items :value="0">
          <v-tab-item>
            <v-row class="py-4" v-if="statistic.types && statistic.types[selected_type]">
              <v-col>
                <div>{{ statistic.types[selected_type].sold_out }}</div>
                <span>已售出</span>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col style="max-width: unset;">
                <div>
                  <div class="peach mr-2"></div>
                  {{ statistic.types[selected_type].sold_peaches }}
                </div>
                <span>總售出桃子</span>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col>
                <div>
                  {{ statistic.new_followers }}
                </div>
                <span>新粉絲</span>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <div class="products wrapper">
        <div class="d-flex mb-4">
          <div>
            <h3>所有商品</h3>
            <span>您的商品狀態及銷售概覽</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn dark color="pink" @click="$refs.newProduct.open()">新增商品</v-btn>
        </div>
        <v-tabs v-model="product_tab" grow :show-arrows="false" color="pink">
          <v-tab>上架中</v-tab>
          <v-tab>已售完</v-tab>
          <v-tab>下架中</v-tab>
        </v-tabs>
        <v-tabs-items class="mt-6" :value="0">
          <v-tab-item>
            <v-row class="table-header">
              <v-col>商品</v-col>
              <v-col>價格</v-col>
              <!-- <v-col>動作</v-col> -->
            </v-row>
            <template v-for="product in products">
              <v-row class="table-content shrink">
                <v-col class="pointer" @click="$func.toProductPage(product.id, seller, product.product_type)">
                  <v-img 
                    :src="$func.productImagePreview(product)"
                    max-width="50"
                    max-height="50"
                    class="mr-2"
                  ></v-img>
                  <div>
                    <div>
                      {{ product.title }}
                      <span class="product-type-chip">{{ $product_types.find(type => type.value == product.product_type).text }}</span>
                    </div>
                    <div class="d-flex align-center review">
                      <template v-if="!['clothes'].includes(product.product_type)">
                        <v-icon>fa-thumbs-up</v-icon>
                        <span>{{ mul(product.praise_rate, 100) }}%</span>
                        <v-icon>fa-unlock</v-icon>
                        <span>{{ product.unlocks }}</span>
                      </template>
                      <v-icon>fa-eye</v-icon>
                      <span>{{ product.views }}</span>
                    </div>
                  </div>
                </v-col>
                <v-col class="pink--text font-weight-bold">
                  <div class="peach"></div>
                  {{ product.price }}
                </v-col>
                <!-- <v-col>
                  <v-btn icon v-if="product_tab == 0">
                    <v-icon color="indigo">edit</v-icon>
                  </v-btn>
                </v-col> -->
              </v-row>
            </template>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-container>

    <NewProduct ref="newProduct" @refresh="refresh"></NewProduct>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import NewProduct from '@/components/portal/NewProduct'
export default {
  components: { NewProduct },
  data() {
    return {
      busy: false,
      page: 1,
      dashboard_types: [
        {text: '全部', value: 'all'},
        ...this.$product_types
      ],
      dashboard_tab: 0,
      product_tab: 0,
      products: [],
      statistic: {}
    }
  },
  computed: {
    ...mapState('seller', ['seller']),
    selected_type() {
      return this.dashboard_types[this.dashboard_tab].value
    }
  },
  watch: {
    product_tab() {
      this.refresh()
    }
  },
  created() {
    this.getStatistic()
  },
  methods: {
    getStatistic() {
      this.axios(`/portal/statistics?start=${this.$moment().format('YYYY-MM-DD')}&end=${this.$moment().add(1, 'days').format('YYYY-MM-DD')}`).then(response => {
        let all_sold_out = Object.values(response.data.types).reduce((prev, type) => {
          return prev + parseInt(type.sold_out)
        }, 0)
        let all_sold_peaches = Object.values(response.data.types).reduce((prev, type) => {
          return prev + parseInt(type.sold_peaches)
        }, 0)
        response.data.types.all = {sold_out: all_sold_out, sold_peaches: all_sold_peaches}
        this.statistic = response.data
      })
    },
    refresh() {
      this.page = 1
      this.products = []
      this.getProducts()
    },
    getProducts() {
      this.busy = true
      let result = []
      let origin = this.product_tab
      this.axios(`/portal/product?page=${this.page}&size=50`).then(response => {
        // change product tab quickly, the old response data will concat the wrong data
        if(origin != this.product_tab) {
          return
        }
        if(this.product_tab == 0) {
          result = response.data.data.filter(product => {
            return !(product.sold > 0 && product.product_type == 'clothes') && product.shelf
          })
        }
        else if(this.product_tab == 1) {
          result = response.data.data.filter(product => {
            return product.sold > 0 && product.product_type == 'clothes'
          })
        }
        else {
          result = response.data.data.filter(product => !product.shelf)
        }

        this.products = this.products.concat(result)
        if(this.page != response.data.last_page) {
          this.page += 1  
          this.busy = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  p {
    color: black !important;
  }
  span:not(.v-btn__content) {
    color: #333;
    font-size: 12px;
    font-weight: 300;
  }
  .overview {
    margin-bottom: 28px;
    .col {
      position: relative;
      max-width: 33%;
      text-align: center;
      padding: 16px;
      div {
        color: $main;
        font-size: 24px;
      }
    }
  }
  .products {
    .product-type-chip {
      font-size: 10px;
      background: $main;
      color: white;
      border-radius: 10px;
      padding: 0 6px;
    }
  }
  .v-slide-group__prev {
    display: none !important;
  }
}
</style>